// extracted by mini-css-extract-plugin
export var content = "_pk-1";
export var fullScreen = "_pk-0";